import { render } from "./AppFooter.vue?vue&type=template&id=78a65322&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=78a65322&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78a65322"

export default script